import Expense from "../expense";


export class ExpenseAccessControl {

    private expense : Expense

    constructor(expense:Expense) {
        this.expense = expense
    }

    get canApprove():boolean {

        if (gd.user.acl.isManager) return true

        if (gd.user.acl.hasManagerAccessToUser(this.expense.userId)) return true

        return false
    }

    get canReimburse():boolean {

        if (gd.user.acl.isManager) return true

        if (gd.user.acl.hasManagerAccessToUser(this.expense.userId)) return true

        return false
    }


}
